module.exports = new __parcel__URL__("teams-howto.de2d8216.svg").toString();